import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import Analytics from './services/analytics';

Analytics.initialize().then(() => {
  ReactDOM.render(<App />, document.getElementById('root'));
});
